.search {
  width: 100%;
}

.icon {
  color: var(--color-text-secondary);
}
